import { cloneProviderClient, unwrap } from './cloneProviderClient';

export const JOB_KINDS = ['recovery', 'health_check', 'buy'];
export const SERVICE_TYPES = ['fb_ql', 'fb_eaaaau', 'fb_eaagno'];
// Giá trị khớp đúng app/enums.py's SystemJob VALUE (không phải tên member)
// - FastAPI validate path param theo value của Enum, không phải tên.
export const SYSTEM_JOBS = ['product_evaluation_loop', 'persister'];

export async function listJobs() {
  const response = await cloneProviderClient.get('/admin/jobs');
  return unwrap(response);
}

export async function startJob(kind, serviceType) {
  const response = await cloneProviderClient.post(`/admin/jobs/${kind}/${serviceType}/start`);
  return unwrap(response);
}

export async function stopJob(kind, serviceType) {
  const response = await cloneProviderClient.post(`/admin/jobs/${kind}/${serviceType}/stop`);
  return unwrap(response);
}

export async function getJobLog(kind, serviceType, lines = 200) {
  const response = await cloneProviderClient.get(`/admin/jobs/${kind}/${serviceType}/log`, { params: { lines } });
  return unwrap(response);
}

export async function getSystemJobLog(name, lines = 200) {
  const response = await cloneProviderClient.get(`/admin/jobs/system/${name}/log`, { params: { lines } });
  return unwrap(response);
}

const jobsService = { listJobs, startJob, stopJob, getJobLog, getSystemJobLog, JOB_KINDS, SERVICE_TYPES, SYSTEM_JOBS };
export default jobsService;
